<template>
  <div styleName="notice" v-show="show">
    <slot></slot>
  </div>
</template>

<script>
import styles from './index.scss'
import CSSModules from 'vue-css-modules'

export default {
  mixins: [CSSModules(styles)],
  props: ['show']
}
</script>

